module.exports = __webpack_public_path__ + "img/122.b03741d5.jpg";